<div class="modal-header border-0 px-lg-5 px-2">
	<span class="modal-title theme-main-color fs-4 fw-bold ms-2 mt-3"
		>Ajout d'une série de prestations</span
	>
	<button
		type="button"
		class="btn-close"
		data-bs-dismiss="modal"
		aria-label="Close"
		(click)="closeModal()"
	></button>
</div>

<div class="modal-body">
	<div class="container-fluid px-lg-5 px-2">
		<div *ngIf="isLoading" class="my-4">
			<div class="row h-75">
				<div
					class="col d-flex justify-content-center align-items-center"
					style="font-size: 24px"
				>
					<div
						class="spinner-border theme-main-color"
						role="status"
						style="width: 3rem; height: 3rem"
					>
						<span class="visually-hidden">Loading...</span>
					</div>
					<!-- <span class="sr-only">Loading...</span> -->
				</div>
			</div>
		</div>
		<div *ngIf="!isLoading" class="row">
			<label
				*ngIf="!!formattedDateRange && formattedDateRange !== ''"
				class="form-label theme-main-color fw-bold my-3"
				>Intervalle de dates ( {{ formattedDateRange }} )</label
			>
			<div [formGroup]="form">
				<div class="col">
					<div
						class="form-inline mb-2"
						*ngIf="!this.parameters.start && !this.parameters.end"
					>
						<div class="pr-3 pb-3 pe-3 w-auto">
							<bs-daterangepicker-inline
								[bsValue]="bsInlineRangeValue"
								[bsConfig]="{ containerClass: 'theme-dark-blue' }"
								(bsValueChange)="onDateRangeChange($event)"
							></bs-daterangepicker-inline>
						</div>
					</div>
					<div class="row mt-3">
						<div class="col-6">
							<label class="form-label theme-main-color fw-bold"
								>Heures à réaliser</label
							>
							<timepicker
								formControlName="requiredHours"
								[showMeridian]="false"
								[readonlyInput]="false"
								[showSpinners]="false"
								[minuteStep]="1"
								class="timepicker"
							></timepicker>
						</div>
						<div class="col-6">
							<label class="form-label theme-main-color fw-bold"
								>Nombre de prestations</label
							>
							<input
								formControlName="numberOfPrestations"
								type="number"
								min="1"
								placeholder="Nombre de prestations"
								class="form-control w-auto"
								(change)="updatePrestationCount($event)"
							/>
						</div>
					</div>
				</div>
				<div class="row mt-3">
					<div class="col-6">
						<label
							for="inputTypeFormation"
							class="form-label theme-main-color fw-bold"
							>Type de prestation</label
						>
						<input
							autocomplete="off"
							(keyup)="typeFormationKeyUp($event.target)"
							formControlName="missionType"
							[typeahead]="listMissionType"
							typeaheadOptionField="type"
							[typeaheadMinLength]="0"
							placeholder="Saisissez un type de prestation"
							class="form-control"
							[typeaheadScrollable]="true"
							(typeaheadOnSelect)="typeaheadTypeFormationOnSelect($event)"
							[ngClass]="{
								'is-invalid':
									missionType.errors?.required || !selectedMissionType
							}"
						/>
						<div
							*ngIf="
								(missionType.invalid &&
									(missionType.dirty ||
										missionType.touched ||
										missionType.errors?.required)) ||
								!selectedMissionType
							"
							class="text-danger"
						>
							<span *ngIf="missionType.errors?.required || !selectedMissionType"
								>Le choix d'un type de prestation est requis</span
							>
						</div>
					</div>
					<div class="col-6">
						<label
							for="inputBeneficiaire"
							class="form-label theme-main-color fw-bold"
							>Bénéficiaire</label
						>
						<input
							autocomplete="off"
							(keyup)="beneficiaireKeyUp($event.target)"
							formControlName="beneficiaire"
							[typeahead]="listBeneficiaireMapped"
							typeaheadOptionField="name"
							[typeaheadItemTemplate]="itemTemplateTypeaheadBeneficiaire"
							[typeaheadMinLength]="0"
							placeholder="Bénéficiaire"
							class="form-control"
							[typeaheadScrollable]="true"
							(typeaheadOnSelect)="typeaheadBeneficiaireOnSelect($event)"
							[ngClass]="{
								'is-invalid': form.errors?.beneficiaireRequired,
								'is-valid':
									beneficiaire.dirty &&
									beneficiaire.valid &&
									!form.errors?.beneficiaireRequired
							}"
						/>
						<ng-template
							#itemTemplateTypeaheadBeneficiaire
							let-model="item"
							let-index="index"
						>
							<span>{{ model.name }}</span>
						</ng-template>
						<div
							*ngIf="
								(beneficiaire.invalid &&
									(beneficiaire.dirty ||
										beneficiaire.touched ||
										beneficiaire.errors?.required)) ||
								!selectedBeneficiaire
							"
							class="text-danger"
						>
							<span
								*ngIf="
									beneficiaire.errors?.required ||
									form.errors?.beneficiaireRequired
								"
								>Le choix d'un bénéficiaire est requis</span
							>
						</div>
					</div>
				</div>
				<div class="row mt-3">
					<div *ngIf="!isAPrescription && selectedBeneficiaire" class="col-6">
						<div class="row">
							<label
								class="form-label theme-main-color fw-bold"
								for="checkRemote"
								>Rappel automatique par email au bénéficiaire</label
							>
						</div>
						<div class="row">
							<div
								class="form-check d-flex justify-content-center align-items-center"
								id="checkReminder"
							>
								<input
									class="form-check-input theme-main-border-color fs-5"
									[ngClass]="{ 'theme-main-color-check': remind }"
									type="checkbox"
									formControlName="remind"
								/>
							</div>
						</div>
					</div>
					<div class="col-6" *ngIf="this.parameters.intervenantId">
						<label for="model" class="form-label fw-bold">Intervenant</label>
						<input
							id="intervenantId"
							class="form-control"
							type="text"
							[value]="
								selectedEmployee?.firstName + ' ' + selectedEmployee?.lastName
							"
							disabled
						/>
					</div>
				</div>
				<div class="row mt-3">
					<div class="col-6">
						<label for="model" class="form-label fw-bold">Service</label>
						<input
							class="form-control"
							autocomplete="off"
							formControlName="centerDepartment"
							placeholder="Saisissez un service"
							[typeahead]="centerDepartments"
							[typeaheadOptionField]="'name'"
							[typeaheadMinLength]="0"
							[typeaheadScrollable]="true"
							(typeaheadOnSelect)="typeaheadCenterDepartmentOnSelect($event)"
							(keyup)="centerDepartmentsKeyUp($event.target)"
							[ngClass]="{
								'is-valid':
									(centerDepartment.dirty || centerDepartment.touched) &&
									centerDepartment.valid &&
									selectedCenterDepartment
							}"
						/>
					</div>
					<div class="col-6" *ngIf="this.parameters.idDemandDH">
						<label for="model" class="form-label fw-bold">N° Dossier DH</label>
						<input
							id="idDemandDH"
							class="form-control"
							type="text"
							[value]="parameters.idDemandDH"
							disabled
						/>
					</div>
				</div>
				<!-- Accordéons dynamiques pour chaque prestation -->
				<div class="accordion mt-4" id="prestationsAccordion">
					<div formArrayName="prestations">
						<div
							*ngFor="
								let prestation of form.get('prestations')['controls'];
								let i = index
							"
							[formGroupName]="i"
						>
							<div class="accordion-item">
								<h2 class="accordion-header" [id]="'heading' + i">
									<button
										class="accordion-button"
										type="button"
										data-bs-toggle="collapse"
										[attr.data-bs-target]="'#collapse' + i"
										aria-expanded="true"
										[attr.aria-controls]="'collapse' + i"
									>
										<label class="form-label theme-main-color fw-bold"
											>{{ getAccordeonPrestationTitle(i) }}
										</label>
									</button>
								</h2>
								<div
									id="collapse{{ i }}"
									class="accordion-collapse collapse"
									[attr.aria-labelledby]="'heading' + i"
								>
									<div class="accordion-body">
										<!-- Date et heure -->
										<div class="row mt-3" *ngIf="bsInlineRangeValue">
											<div class="col">
												<div class="form-group mb-2">
													<label
														for="datepicker{{ i }}"
														class="form-label theme-main-color fw-bold"
														>Date
													</label>
													<input
														autocomplete="off"
														type="text"
														bsDatepicker
														class="form-control"
														id="datepicker{{ i }}"
														formControlName="date"
														name="date"
														[bsConfig]="bsConfig"
														[ngClass]="{
															'is-invalid':
																prestations.controls[i].get('date').invalid,
															'is-valid':
																prestations.controls[i].get('date').dirty &&
																prestations.controls[i].get('date').valid
														}"
													/>
													<div
														*ngIf="isDateInvalid(i)"
														class="invalid-feedback"
													>
														<span
															*ngIf="
																prestations.controls[i].get('date').errors
																	?.required
															"
															>Une date est requise</span
														>
													</div>
												</div>
												<div
													*ngIf="isDateOutOfRange(i)"
													class="alert alert-warning py-1 px-2 mt-1 mb-0"
												>
													<i class="bi bi-exclamation-triangle-fill"></i>
													<span> Date en dehors de la période définie.</span>
												</div>
											</div>
											<div class="col">
												<div class="form-group mb-2">
													<label class="form-label theme-main-color fw-bold"
														>Début</label
													>
													<timepicker
														formControlName="readyTime"
														[min]="minWorkingHourAsDate"
														[max]="maxWorkingHourAsDate"
														[showMeridian]="false"
														[readonlyInput]="false"
														[showSpinners]="false"
														[minuteStep]="1"
														class="timepicker"
													></timepicker>
													<div
														*ngIf="
															prestations.controls[i].get('readyTime').invalid
														"
														class="text-danger"
													>
														<span
															*ngIf="
																prestations.controls[i].get('readyTime').errors
																	?.required
															"
															>Un horaire est requis</span
														>
														<span
															*ngIf="
																prestations.controls[i].get('readyTime').errors[
																	'outOfRange'
																]
															"
															>Veuillez saisir un horaire entre
															{{ MIN_WORKING_HOUR }}h et
															{{ MAX_WORKING_HOUR }}h</span
														>
													</div>
												</div>
											</div>
											<div class="col">
												<div class="form-group mb-2">
													<label class="form-label theme-main-color fw-bold"
														>Fin</label
													>
													<timepicker
														formControlName="dueTime"
														[min]="minWorkingHourAsDate"
														[max]="maxWorkingHourAsDate"
														[showMeridian]="false"
														[readonlyInput]="false"
														[showSpinners]="false"
														[minuteStep]="1"
														class="timepicker"
													></timepicker>
													<div
														*ngIf="
															prestations.controls[i].get('dueTime').invalid
														"
														class="text-danger"
													>
														<span
															*ngIf="
																prestations.controls[i].get('dueTime').errors
																	?.required
															"
															>Un horaire est requis</span
														>
														<span
															*ngIf="
																prestations.controls[i].get('dueTime').errors[
																	'outOfRange'
																]
															"
															>Veuillez saisir un horaire entre
															{{ MIN_WORKING_HOUR }}h et
															{{ MAX_WORKING_HOUR }}h</span
														>
													</div>
												</div>
											</div>
											<div
												*ngIf="
													prestations.controls[i].errors &&
													(prestations.controls[i].errors.endBeforeStart ||
														prestations.controls[i].errors.tooManyHours)
												"
												class="row my-2 text-center"
											>
												<span
													*ngIf="prestations.controls[i].errors.endBeforeStart"
													class="text-danger"
													>Veuillez saisir une heure de début inférieure à
													l'heure de fin</span
												>
												<span
													*ngIf="prestations.controls[i].errors.tooManyHours"
													class="text-danger"
													>La durée de la prestation ne peut excéder
													{{ MAX_DURATION }}h</span
												>
											</div>
										</div>
										<!-- Lieu + Checkbox Visio -->
										<div class="row mt-3">
											<div
												*ngIf="prestations.controls[i].get('isRemote').value"
												class="col-6"
											>
												<div class="alert alert-secondary" role="alert">
													<p class="theme-main-color">
														<i
															class="bi bi-info-circle me-2"
															aria-hidden="true"
														></i>
														<em
															>Le lien de la visio sera consultable après la
															validation du formulaire.</em
														>
													</p>
												</div>
											</div>
											<div
												class="col-6"
												*ngIf="
													!isReunion &&
													!prestations.controls[i].get('isRemote').value
												"
											>
												<label
													for="inputMissionPlace"
													class="form-label theme-main-color fw-bold"
													>Lieu de prestation</label
												>
												<input
													autocomplete="off"
													(keyup)="missionPlaceKeyUp($event.target, i)"
													[formControl]="getMissionPlaceNameControl(i)"
													[typeahead]="listMissionPlace"
													typeaheadOptionField="nameDisplay"
													[typeaheadItemTemplate]="
														itemTemplateTypeaheadMissionPlace
													"
													[typeaheadMinLength]="0"
													placeholder="{{
														isAPrescription
															? 'Visio'
															: 'Saisissez un lieu de prestation'
													}}"
													class="form-control"
													[typeaheadScrollable]="true"
													(typeaheadOnSelect)="
														typeaheadMissionPlaceOnSelect($event, i)
													"
													[disabled]="
														!prestations.controls[i].get(
															'isMissionPlaceBeneficiaireAddress'
														).value
													"
													[ngClass]="{
														'is-invalid':
															!isAPrescription &&
															(prestations.controls[i].errors
																?.missionPlaceRequired ||
																!prestations.controls[i].get('missionPlace')
																	.valid),
														'is-valid':
															isAPrescription ||
															(prestations.controls[i].get('missionPlace')
																.dirty &&
																prestations.controls[i].get('missionPlace')
																	.valid &&
																!prestations.controls[i].errors
																	?.missionPlaceRequired)
													}"
												/>
												<ng-template
													#itemTemplateTypeaheadMissionPlace
													let-model="item"
													let-index="index"
												>
													<span>{{ model.nameDisplay }}</span>
												</ng-template>
												<div
													*ngIf="
														prestations.controls[i].get('missionPlace')
															.invalid &&
														(prestations.controls[i].get('missionPlace')
															.dirty ||
															prestations.controls[i].get('missionPlace')
																.touched ||
															prestations.controls[i].get('missionPlace').errors
																?.required)
													"
													class="text-danger"
												>
													<span
														*ngIf="
															prestations.controls[i].errors
																?.missionPlaceRequired ||
															prestations.controls[i].get('missionPlace').errors
																?.required
														"
														>Le choix d'un lieu de prestation est requis</span
													>
												</div>
											</div>

											<div *ngIf="displayBeneficiaireLocation(i)" class="col-3">
												<div class="row">
													<label
														class="form-label theme-main-color fw-bold"
														for="checkMissionPlaceBeneficiaire"
													>
														au domicile
													</label>
												</div>
												<div class="row">
													<div
														class="form-check d-flex justify-content-center align-items-center"
														id="checkMissionPlaceBeneficiaire"
													>
														<input
															(change)="resetMissionPlace(i)"
															class="form-check-input theme-main-border-color fs-5"
															[ngClass]="{
																'theme-main-color-check': prestations.controls[
																	i
																].get('isMissionPlaceBeneficiaireAddress').value
															}"
															type="checkbox"
															formControlName="isMissionPlaceBeneficiaireAddress"
														/>
														<span *ngIf="isAlertAddressBeneficiaireNeeded(i)">
															<span class="fw-bold theme-red-color"
																>L'adresse du bénéficiaire est incorrecte
															</span>
															<a
																(click)="closeModal()"
																[routerLink]="[
																	'/gestion/beneficiaires/',
																	selectedBeneficiaire.id
																]"
																class="theme-main-color"
																>modifier</a
															>
														</span>
													</div>
												</div>
											</div>

											<div *ngIf="!isAPrescription" class="col-3">
												<div class="row">
													<label
														class="form-label theme-main-color fw-bold"
														for="checkRemote"
														>à distance</label
													>
												</div>
												<div class="row">
													<div
														class="form-check d-flex justify-content-center align-items-center"
														id="checkRemote"
													>
														<input
															(change)="resetMissionPlace(i)"
															class="form-check-input theme-main-border-color fs-5"
															[ngClass]="{
																'theme-main-color-check':
																	prestations.controls[i].get('isRemote').value
															}"
															type="checkbox"
															formControlName="isRemote"
														/>
													</div>
												</div>
											</div>
										</div>
										<!-- Compétence + Temps de Prépa -->
										<div class="row mt-3">
											<div
												*ngIf="
													prestations.controls[i].get('competences') &&
													!isReunion
												"
												class="col-6 col-lg"
											>
												<label for="competences" class="form-label fw-bold"
													>Compétence(s)</label
												>
												<div class="row">
													<div
														*ngFor="
															let competence of listCompetences
																| orderBy : 'name' : 'asc'
														"
													>
														<span class="col check">
															<input
																[type]="'checkbox'"
																[id]="competence.id"
																name="{{ competence.name }}"
																class="form-check-input"
																[value]="competence"
																[checked]="isCompetenceCheck(competence, i)"
																[ngClass]="{
																	'theme-main-color-check': isCompetenceCheck(
																		competence,
																		i
																	)
																}"
																[disabled]="
																	isProfessionnelSAE ||
																	(isSAE &&
																		isCompetencesElementaires(competence))
																"
																(change)="
																	updateSelectedCompetence(
																		$event,
																		competence,
																		i
																	)
																"
															/>
															<label
																[for]="competence.id"
																class="ms-2 form-check-label text-dark"
																>{{
																	competence.name.replaceAll('_', ' ')
																}}</label
															>
														</span>
													</div>
												</div>
											</div>
											<div
												class="col-6 col-lg"
												*ngIf="!isReunion && !isAPrescription"
											>
												<label
													for="inputSpeciality"
													class="form-label theme-main-color fw-bold"
													>Spécialité</label
												>
												<input
													autocomplete="off"
													(keyup)="specialityKeyUp($event.target, i)"
													formControlName="specialty"
													[typeahead]="listCareSpecialty"
													typeaheadOptionField="name"
													[typeaheadItemTemplate]="
														itemTemplateTypeaheadSpeciality
													"
													[typeaheadMinLength]="0"
													placeholder="Saisissez une spécialité"
													class="form-control"
													[typeaheadScrollable]="true"
													(typeaheadOnSelect)="
														typeaheadSpecialityOnSelect($event, i)
													"
												/>
												<ng-template
													#itemTemplateTypeaheadSpeciality
													let-model="item"
													let-index="index"
												>
													<span>{{ model.name }}</span>
												</ng-template>
											</div>
											<!-- <div class="row my-4" *ngIf="!isReunion && isSESSAD">
												<div class="col-12">
													<label
														for="inputEmployee"
														class="form-label theme-main-color fw-bold"
														>Temps de préparation:</label
													>
													<select
														class="form-select form-control"
														id="preparationTimePercentage"
														[formControlName]="'preparationTimePercentage'"
														aria-label="Temps de préparation"
													>
														<option
															*ngFor="
																let preparationTime of preparationTimeList
															"
															value="{{ preparationTime.time }}"
														>
															{{ preparationTime.label }} ({{
																preparationTime.time
															}}%)
														</option>
													</select>
												</div> 
											</div>-->
										</div>
										<!-- Notes -->
										<div class="row my-4">
											<div class="col">
												<label
													for="inputNotes"
													class="form-label theme-main-color fw-bold"
													>Notes</label
												>
												<textarea
													class="form-control"
													id="inputNotes"
													formControlName="notes"
													[ngClass]="{
														'is-invalid':
															prestations.controls[i].get('notes').invalid,
														'is-valid':
															prestations.controls[i].get('notes').dirty &&
															prestations.controls[i].get('notes').valid
													}"
												></textarea>
												<div
													*ngIf="
														prestations.controls[i].get('notes').invalid &&
														(prestations.controls[i].get('notes').dirty ||
															prestations.controls[i].get('notes').touched)
													"
													class="invalid-feedback"
												>
													<span
														*ngIf="
															prestations.controls[i].get('notes').errors
																?.maxlength
														"
														>Taille maximale atteinte</span
													>
												</div>
											</div>
										</div>
										<!-- Employés Disponibles SAE -->
										<div
											class="row mt-2"
											*ngIf="
												isSAE &&
												!isProjectManager &&
												!isProfessionnelTerrain &&
												!this.parameters.intervenantId
											"
										>
											<app-list-available-employees
												[date]="prestations.controls[i].get('date').value"
												[readyTime]="
													prestations.controls[i].get('readyTime').value
												"
												[dueTime]="prestations.controls[i].get('dueTime').value"
												[careSkills]="getCareSkills(i)"
												[missionType]="selectedMissionType"
												[specialty]="getSpecialty(i)"
												[address]="getMissionLocation(i)"
												[isRemote]="
													prestations.controls[i].get('isRemote').value
												"
												(selectedEmployeeEmitter)="selectEmployee($event, i)"
											>
											</app-list-available-employees>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- Fin accordéon -->
				<!-- Boutons -->
				<div class="row my-5">
					<div class="d-flex justify-content-end">
						<button
							class="btn theme-main-color-button mx-3 px-3"
							type="button"
							(click)="closeModal()"
						>
							Retour
						</button>
						<button
							[disabled]="shouldSubmitButtonBeDisabled()"
							class="btn theme-green-button"
							type="submit"
							form="formAjout"
							(click)="onSubmit()"
						>
							<i class="bi bi-save-fill px-1" aria-hidden="true"></i>Sauvegarder
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
